import { Helmet } from 'react-helmet';
import {
    Avatar,
    Box, Button, Card, CardContent,
    Container, Divider,
    Grid, Tab, Tabs, Toolbar, Typography, tableCellClasses, ClickAwayListener, Rating, MenuItem, Select, TextField, InputAdornment
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import axios from "axios";
import cssVariables from "../../../theme/cssVariables";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import exports from "../../../assets/images/export.png";
import teamMember from "../../../assets/images/viewDashboard.svg";
import emty from "../../../assets/images/emty.png";
import { ReactComponent as ListFile } from "../../../assets/images/listFile.svg";
import { ReactComponent as TooltipIcon } from "../../../assets/images/tooltip.svg";
import { ReactComponent as BtnFilter } from "../../../assets/images/btn-filter.svg";
import { ReactComponent as ArrowRight } from "../../../assets/images/conpetency-arrow-right.svg";
import core from "../../../assets/images/core.svg";
import functional from "../../../assets/images/Functional.svg";
import managerial from "../../../assets/images/Managerial.svg";
import { useParams } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import MenuFilter from "../../../components/kpi/MenuFilter";
import myCompetencies from "../../../icons/myCompetencies.png";
import competencyService from "../../../services/competency.service";
import emtyData from "../../../assets/images/emty-data.png";

const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};
const useStyles = makeStyles({
    media: {
        height: 200,
    },
});
const Planing = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let { serial } = useParams();
    const classes = useStyles();
    const Root = styled('div')(({ theme }) => ({
        padding: "25px",
        display: "flex",
        background: "#FFFFFF",
        cursor: "pointer",
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        [theme.breakpoints.down('md')]: {
            width: "calc(50% - 35px)",
            margin: "30px 17.5px 0"
        },
        [theme.breakpoints.up('md')]: {
            width: "calc(33.33% - 35px)",
            margin: "30px 17.5px 0"
        },
        [theme.breakpoints.up('lg')]: {
            width: "calc(25% - 35px)",
            margin: "30px 17.5px 0"
        },
    }));

    const [competencyFormSelect, setCompetencyForm] = React.useState([]);
    const [competencyFormSelectValue, setCompetencyFormValue] = React.useState("");
    const handleChangeWorkloadForm = (event) => {
        setCompetencyFormValue(event.target.value);
    };
    const [dataTeam, setDataTeam] = React.useState([]);
    let getDataTeamMember = (data) => {
        if (formatData(data, false) !== false) {
            competencyService.competency(`app/kpi/competency/team/members?kpi_form_id=${data}`).then(
                (response) => {
                    if (formatData(response.data.members, false) !== false && response.data.members.length > 0) {
                        setDataTeam(response.data.members)
                    }
                },
            );
        } else {
            competencyService.competency(`app/kpi/competency/team/members`).then(
                (response) => {
                    if (formatData(response.data.members, false) !== false && response.data.members.length > 0) {
                        setDataTeam(response.data.members)
                    }
                },
            );
        }
    }
    let getDataCompetencyYear = () => {
        competencyService.competencyYear().then(
            (response) => {
                setCompetencyForm(response.data)
                if (response.data.length > 0) {
                    let filterData = response.data.filter((e) => e.is_default === true)
                    if (filterData.length > 0) {
                        setCompetencyFormValue(filterData[0].value)
                    } else {
                        setCompetencyFormValue(response.data[0].value)
                    }
                }
            },
        );
    }
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    useEffect(() => {
        // getDataCompetencyYear()
        getDataTeamMember()
    }, []);
    // useEffect(() => {
    //     if (competencyFormSelectValue !== null && competencyFormSelectValue !== undefined && competencyFormSelectValue !== "") {
    //         getDataTeamMember(competencyFormSelectValue)
    //     }
    // }, [competencyFormSelectValue]);
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    return (
        <Box className="asd" style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.end} >{t('competency.teamMember')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", width: "100%" }}>
                                <Box>
                                    <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" pb={"5px"}>
                                        {t('competency.teamMember')}
                                    </Typography>
                                    <Typography color="#9E9E9E" fontSize={16} lineHeight="24px" fontWeight="300">
                                        {t('competency.totalMember')}: {dataTeam !== undefined && dataTeam.length > 0 ? dataTeam.length : "0"} {t('competency.member')}
                                    </Typography>
                                </Box>
                                {/* <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    flexDirection="row"
                                >
                                    <Select
                                        id="workload-select"
                                        inputlabelprops={{ shrink: false }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ width: "400px" }}
                                        className="white-bg"
                                        value={competencyFormSelectValue}
                                        onChange={handleChangeWorkloadForm}
                                    >
                                        {
                                            competencyFormSelect?.length > 0 ?
                                                competencyFormSelect.map(item => {
                                                    return (
                                                        <MenuItem value={item.value} key={item.value}>
                                                            {item.name}
                                                        </MenuItem>
                                                    )
                                                })

                                                : <MenuItem value="">
                                                    ---{t('label.notFund')}---
                                                </MenuItem>
                                        }
                                    </Select>
                                </Box> */}
                            </Box>
                        </Grid>
                        <Box pl="16px" pb="30px" width="100%">
                            <Box sx={{ display: "flex", "flex-flow": "row wrap", margin: "0 -17.5px" }}>
                                {dataTeam !== undefined && dataTeam.length > 0 ?
                                    dataTeam.map(item => (
                                        <Root onClick={e => navigate('/kpi/competency/' + item.serial, { replace: false })}>
                                            <Box>
                                                <Avatar
                                                    src={formatData(item?.photo, "")}
                                                    sx={{
                                                        // cursor: "pointer",
                                                        width: 50,
                                                        height: 50,
                                                    }}
                                                />
                                            </Box>
                                            <Box pl="15px" sx={{ width: "calc(100% - 50px)" }}>
                                                <Typography color="#404349" fontSize={18} lineHeight="27px" fontWeight="400" pb="2px" sx={{ overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis", width: "100%" }}>
                                                    {formatData(item?.fullname, "-")}
                                                </Typography>
                                                <Typography color="#A3A3A3" fontSize={14} lineHeight="21px" fontWeight="300" sx={{ overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis", width: "100%" }}>
                                                    {formatData(item?.position, "-")}
                                                </Typography>
                                            </Box>
                                        </Root>
                                    ))
                                    :
                                    <Grid container mt={5} >
                                        <Grid item xs sm md display="flex" flexDirection="column" alignItems="center">
                                            <Box>
                                                <img src={emtyData} alt="emty-data" />
                                            </Box>
                                            <Box pt={2}>
                                                <Typography variant="h1" fontSize={14} lineHeight="21px" fontWeight="300" color="#939393">
                                                    {t('label.noData')}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                }
                            </Box>
                        </Box>
                    </Grid>
                </Container>
            </Box>
        </Box >
    )
};
export default Planing;
